import Input from '../../main-booking-panel/parts/fields/PassengerInput'

class PassengerInput extends Input {
    constructor(domElement = null, data = {}) {
        super(domElement, data)
    }
}

export default PassengerInput
